import { useEffect, useState } from "react";
import { CSSTransition } from "react-transition-group";
import styled, { css } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import copy from "copy-to-clipboard";

import icons from "icons";

function ShareButton(props: any) {
   const Container = styled.button`
      padding: 0%;
   `;
   const ShareIcon = styled.div`
      width: 20px;
      height: 20px;
      color: #7c7c7c;
      padding: 10px;
      box-sizing: content-box;
      transition-property: opacity;
      transition-duration: 0.3s;
      transition-timing-function: ease-in-out;
      & img {
         width: 100%;
         height: auto;
      }
      &:hover {
         opacity: 0.8;
      }
   `;

   return (
      <Container onClick={props.onClick}>
         <ShareIcon>
            <img src={props.src} alt="" />
         </ShareIcon>
      </Container>
   );
}
function SNSButton(props: any) {
   const Container = styled.button`
      padding: 5px;
      transition-property: opacity;
      transition-timing-function: ease-in-out;
      transition-duration: 0.3s;
      &:hover {
         opacity: 0.8;
      }
   `;
   const SNSIcon = styled.div`
      width: 32px;
      height: 32px;
      & img {
         width: 100%;
         height: auto;
      }
   `;

   return (
      <Container onClick={props.onClick}>
         <SNSIcon>
            <img src={props.src} alt="" />
         </SNSIcon>
      </Container>
   );
}

export default function Share(props: any) {
   const [isVisible, setVisible] = useState(false);

   const Container = styled.div<any>`
      position: relative;
      display: inline-block;
      & button {
         border: none;
         outline: none;
         background-color: transparent;
         cursor: pointer;
      }
   `;
   const AnimationContainer = styled.div`
      position: absolute;
      left: 100%;
      top: 50%;
      width: 0px;
      height: 0px;
      transition-property: all;
      transition-timing-function: ease-in-out;
      transition-duration: 0.5s;
      transform: translateY(-50%);
      overflow: hidden;
      border-radius: 50%;
      .visible-enter & {
         width: 0px;
         height: 0px;
         border-radius: 100%;
      }
      .visible-enter-active & {
         width: 193px;
         height: 90px;
         border-radius: 0;
      }
      .visible-enter-done & {
         width: 193px;
         height: 90px;
         border-radius: 0;
      }
      .visible-exit & {
         width: 193px;
         height: 90px;
         border-radius: 0;
      }
      .visible-exit-active & {
         width: 0px;
         height: 0px;
         border-radius: 100%;
      }
      .visible-exit-done & {
         width: 0px;
         height: 0px;
         border-radius: 100%;
      }
   `;

   const ButtonsContainer = styled.div`
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
      background-color: #fff;
      border-radius: 10px;
      padding: 7px 20px;
      width: 166px;
      box-sizing: border-box;
   `;

   const Triangle = styled.div`
      overflow: hidden;
      position: absolute;
      left: -30px;
      top: 50%;
      width: 30px;
      height: 30px;
      transform: translateY(-50%);
      &:before {
         content: "";
         display: block;
         position: absolute;
         transform: translate(-50%, -50%) rotate(45deg);
         background-color: white;
         width: 15px;
         height: 15px;
         left: 100%;
         top: 50%;
         box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
      }
   `;

   function shareButtonOnClick() {
      if (isVisible) {
         setVisible(false);
      } else {
         setVisible(true);
      }
   }
   function facebookShareOnClick() {
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(window.location.href), "facebook-share", "width=800,height=600");
   }
   function kakaoShareOnClick() {
      if (!(window as any).Kakao) return false;
      const kakao = (window as any).Kakao;

      // 중복 initialization 방지
      // 카카오에서 제공하는 javascript key를 이용하여 initialize
      if (!kakao.isInitialized()) {
         kakao.init("d25482c1c04f4b2316004c918743577e");
      }

      kakao.Share.sendScrap({
         requestUrl: window.location.href,
      });
   }
   function copyOnClick() {
      if (copy(window.location.href)) {
         alert("복사 되었습니다.");
      }
   }

   return (
      <CSSTransition in={isVisible} timeout={500} classNames="visible">
         <Container>
            <AnimationContainer className={"animation-container"}>
               <ButtonsContainer>
                  <Triangle />
                  <SNSButton onClick={copyOnClick} src={icons.iconCopy}></SNSButton>
                  <SNSButton onClick={facebookShareOnClick} src={icons.iconFacebook}></SNSButton>
                  <SNSButton onClick={kakaoShareOnClick} src={icons.iconKakaotalk}></SNSButton>
               </ButtonsContainer>
            </AnimationContainer>
            <ShareButton src={icons.iconShare} onClick={shareButtonOnClick} />
         </Container>
      </CSSTransition>
   );
}
